module.exports = __webpack_public_path__ + "img/i_calendar.86754259.svg";